import { render } from "./ResultsBanner.vue?vue&type=template&id=4910cb68&scoped=true"
import script from "./ResultsBanner.vue?vue&type=script&lang=js"
export * from "./ResultsBanner.vue?vue&type=script&lang=js"

import "./ResultsBanner.vue?vue&type=style&index=0&id=4910cb68&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1706908206/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4910cb68"]])

export default __exports__